import { useMutation, useQuery } from "@tanstack/react-query";
import { APIs } from "../api/APIs";
import { api } from "../api";

export const useCaptcha = () => {
  const useGetCaptchaId = (keys, select) => {
    const { enabled } = keys;

    const api_info = APIs.captcha.get_id();
    return useQuery({
      queryKey: ["/site-common/captcha/generate", keys],
      queryFn: async () => await api(api_info),
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      select,
      enabled,
      // staleTime: 1000 * 60 * 5,
    });
  };

  const useGetCaptchaText = (keys, select) => {
    const { captchaId } = keys;

    const api_info = APIs.captcha.get_text(captchaId);
    return useQuery({
      queryKey: ["/site-common/captcha/{captchaId}", keys],
      queryFn: async () => await api(api_info),
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      select,
    });
  };

  const verifyCaptchaMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.captcha.verify(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  return {
    useGetCaptchaId,
    useGetCaptchaText,
    verifyCaptchaMutation,
  };
};
